import type { ToolDefinition } from "../types";
import optimizeWebImageTool from "./optimize-web-image";
import svgImageOptimizerTool from "./svg-image-optimizer";
import optimizeImageCustomTool from "./optimize-image-custom";

export const optimizationTools: ToolDefinition[] = [
  optimizeWebImageTool,
  svgImageOptimizerTool,
  optimizeImageCustomTool,
];

export { default as optimizeWebImageTool } from "./optimize-web-image";
export { default as svgImageOptimizerTool } from "./svg-image-optimizer";
export { default as optimizeImageCustomTool } from "./optimize-image-custom";
